/**
 * prerender.js — reveal the build-time prerendered markup once hydrated
 * ─────────────────────────────────────────────────────────────────────
 * Marketing pages ship their markup in #root[data-pre], hidden by a rule in
 * index.html so a visitor never sees it before the app has taken over (the
 * phone layout settles on the client). <Seo> calls this after the route's
 * first effects; main.jsx keeps a timed fallback.
 */
export function revealPrerender() {
  if (typeof document === 'undefined') return;
  const root = document.getElementById('root');
  if (root && root.hasAttribute('data-pre')) root.removeAttribute('data-pre');
}
